module.exports = __webpack_public_path__ + "static/media/home.1d1d32ad.svg";